export default "__VITE_ASSET__DQtl$5yy__"